module.exports = "pegasus/assets/blocks/column-10-theme6.png";